import React, { useState, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/BottomBar.css';

// TWINT temporairement désactivé (passer à true pour réactiver)
const TWINT_ENABLED = false;

const BottomBar = () => {
  const [openGuide, setOpenGuide] = useState(null);
  const [showVideoHelp, setShowVideoHelp] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const videoTutorials = [
    { id: 'inscription', icon: '📝', url: '/videos/video1-inscription.html' },
    { id: 'stripe', icon: '💳', url: '/videos/video2-stripe.html' },
    { id: 'publier-article', icon: '📦', url: '/videos/video3-publier-article.html' },
    { id: 'publier-voiture', icon: '🚗', url: '/videos/video4-publier-voiture.html' },
    { id: 'acheter', icon: '🛒', url: '/videos/video5-acheter.html' },
  ];

  const guides = useMemo(() => [
    {
      id: 'seller-account',
      title: t('guides.sellerAccount.title'),
      icon: '\u{1F3EA}',
      steps: [
        { text: t('guides.sellerAccount.step1') },
        { text: t('guides.sellerAccount.step2') },
        { text: t('guides.sellerAccount.step3') },
        { text: t('guides.sellerAccount.step4') },
        { text: t('guides.sellerAccount.step5') },
        { text: t('guides.sellerAccount.step6') },
      ],
      note: t('guides.sellerAccount.note'),
      image: '/images/seller-success.png',
      imageAlt: t('guides.sellerAccount.imageAlt'),
      imageCaption: t('guides.sellerAccount.imageCaption'),
      link: '/seller/onboarding',
      linkText: t('guides.sellerAccount.linkText')
    },
    {
      id: 'sell-item',
      title: t('guides.sellItem.title'),
      icon: '\u{1F4E6}',
      steps: [
        { text: t('guides.sellItem.step1') },
        { text: t('guides.sellItem.step2') },
        { text: t('guides.sellItem.step3') },
        { text: t('guides.sellItem.step4') },
        { text: t('guides.sellItem.step5') },
        { text: t('guides.sellItem.step6') },
      ],
      note: t('guides.sellItem.note'),
      link: '/create-product',
      linkText: t('guides.sellItem.linkText')
    },
    {
      id: 'buy-item',
      title: t('guides.buyItem.title'),
      icon: '\u{1F6D2}',
      steps: [
        { text: t('guides.buyItem.step1') },
        { text: t('guides.buyItem.step2') },
        { text: t('guides.buyItem.step3') },
        { text: t('guides.buyItem.step4') },
        { text: t('guides.buyItem.step5') },
        { text: t('guides.buyItem.step6') },
      ],
      note: t('guides.buyItem.note'),
      link: '/',
      linkText: t('guides.buyItem.linkText')
    },
    {
      id: 'install-app',
      title: t('guides.installApp.title'),
      icon: '\u{1F4F2}',
      steps: [
        { text: t('guides.installApp.step1') },
        { text: t('guides.installApp.step2') },
        { text: t('guides.installApp.step3') },
        { text: t('guides.installApp.step4') },
        { text: t('guides.installApp.step5') },
      ],
      note: t('guides.installApp.note'),
    },
    {
      id: 'what-is-stripe',
      title: t('guides.whatIsStripe.title'),
      icon: '\u{1F4B3}',
      steps: [
        { text: t('guides.whatIsStripe.step1') },
        { text: t('guides.whatIsStripe.step2') },
        { text: t('guides.whatIsStripe.step3') },
        { text: t('guides.whatIsStripe.step4') },
        { text: t('guides.whatIsStripe.step5') },
        { text: t('guides.whatIsStripe.step6') },
      ],
      note: t('guides.whatIsStripe.note'),
      link: '/seller/onboarding',
      linkText: t('guides.whatIsStripe.linkText')
    }
  ], [t]);

  const toggleGuide = (id) => {
    setOpenGuide(openGuide === id ? null : id);
  };

  const handleNavigate = (path) => {
    setOpenGuide(null);
    navigate(path);
  };

  return (
    <div className="bottom-bar">
      {/* Panel ouvert */}
      {openGuide && (
        <div className="bottom-bar-panel">
          <div className="bottom-bar-panel-header">
            <h3>
              <span>{guides.find(g => g.id === openGuide)?.icon}</span>
              {guides.find(g => g.id === openGuide)?.title}
            </h3>
            <button className="bottom-bar-close" onClick={() => setOpenGuide(null)}>&times;</button>
          </div>
          <div className="bottom-bar-panel-content">
            <ol className="guide-steps">
              {guides.find(g => g.id === openGuide)?.steps.map((step, i) => (
                <li key={i}>{step.text}</li>
              ))}
            </ol>
            {guides.find(g => g.id === openGuide)?.note && (
              <div className="guide-note">
                {guides.find(g => g.id === openGuide).note}
              </div>
            )}
            {guides.find(g => g.id === openGuide)?.image && (
              <div className="guide-image-block">
                <img
                  src={guides.find(g => g.id === openGuide).image}
                  alt={guides.find(g => g.id === openGuide).imageAlt || ''}
                />
                {guides.find(g => g.id === openGuide)?.imageCaption && (
                  <p className="guide-image-caption">{guides.find(g => g.id === openGuide).imageCaption}</p>
                )}
              </div>
            )}
            {guides.find(g => g.id === openGuide)?.link && (
              <button
                className="guide-action-btn"
                onClick={() => handleNavigate(guides.find(g => g.id === openGuide).link)}
              >
                {guides.find(g => g.id === openGuide)?.linkText}
              </button>
            )}
          </div>
        </div>
      )}

      {/* Barre des guides + paiements */}
      <div className="bottom-bar-strip">
        <span className="bottom-bar-label">{t('guides.helpLabel')}</span>
        {guides.map(guide => (
          <button
            key={guide.id}
            className={`bottom-bar-item ${openGuide === guide.id ? 'active' : ''}`}
            onClick={() => toggleGuide(guide.id)}
          >
            <span>{guide.icon}</span>
            <span>{guide.title}</span>
          </button>
        ))}

        {/* Separateur */}
        <div className="bottom-bar-separator"></div>

        {/* Modes de paiement */}
        <div className="bottom-bar-payment-methods">
          <span className="payment-label">{t('guides.paymentLabel')}</span>
          <div className="payment-icons">
            {TWINT_ENABLED && <svg className="payment-icon-svg" viewBox="0 0 48 32" title="TWINT"><rect width="48" height="32" rx="4" fill="#000"/><text x="24" y="20.5" textAnchor="middle" fill="#fff" fontSize="11" fontWeight="bold" fontFamily="Arial,sans-serif" translate="no">TWINT</text></svg>}
            <svg className="payment-icon-svg" viewBox="0 0 48 32" title="Visa"><rect width="48" height="32" rx="4" fill="#1A1F71"/><text x="24" y="21" textAnchor="middle" fill="#fff" fontSize="14" fontWeight="bold" fontFamily="Arial,sans-serif">VISA</text></svg>
            <svg className="payment-icon-svg" viewBox="0 0 48 32" title="Mastercard"><rect width="48" height="32" rx="4" fill="#252525"/><circle cx="19" cy="16" r="10" fill="#EB001B"/><circle cx="29" cy="16" r="10" fill="#F79E1B"/><path d="M24 8.8a10 10 0 0 1 0 14.4 10 10 0 0 1 0-14.4z" fill="#FF5F00"/></svg>
            <svg className="payment-icon-svg" viewBox="0 0 48 32" title="Maestro"><rect width="48" height="32" rx="4" fill="#000"/><circle cx="19" cy="16" r="10" fill="#0099DF"/><circle cx="29" cy="16" r="10" fill="#ED1C2E"/><path d="M24 8.8a10 10 0 0 1 0 14.4 10 10 0 0 1 0-14.4z" fill="#6C6BBD"/></svg>
          </div>
        </div>
      </div>

      {/* Panel video tutos */}
      {showVideoHelp && (
        <div className="bottom-bar-panel video-help-panel">
          <div className="bottom-bar-panel-header">
            <h3>
              <span>{'\u{1F3AC}'}</span>
              {t('guides.videoHelpTitle')}
            </h3>
            <button className="bottom-bar-close" onClick={() => setShowVideoHelp(false)}>&times;</button>
          </div>
          <div className="bottom-bar-panel-content">
            <div className="video-help-grid">
              {videoTutorials.map((video) => (
                <a
                  key={video.id}
                  href={video.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-help-card"
                >
                  <span className="video-help-icon">{video.icon}</span>
                  <span className="video-help-label">{t(`guides.videoTutorials.${video.id}`)}</span>
                  <span className="video-help-arrow">›</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Barre des liens - tout en bas */}
      <div className="bottom-bar-links-strip">
        <button className="bottom-bar-ext-link bottom-bar-help-btn" onClick={() => { setShowVideoHelp(!showVideoHelp); setOpenGuide(null); }}>
          <span>{'\u{1F3AC}'}</span>
          <span>{t('guides.videoHelpBtn')}</span>
        </button>
        <div className="bottom-bar-links-dot"></div>
        <a href="https://www.instagram.com/main2main.ch/" target="_blank" rel="noopener noreferrer" className="bottom-bar-ext-link">
          <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><defs><radialGradient id="ig" cx="30%" cy="107%" r="150%"><stop offset="0%" stopColor="#fdf497"/><stop offset="5%" stopColor="#fdf497"/><stop offset="45%" stopColor="#fd5949"/><stop offset="60%" stopColor="#d6249f"/><stop offset="90%" stopColor="#285AEB"/></radialGradient></defs><path fill="url(#ig)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
          <span>Instagram</span>
        </a>
        <div className="bottom-bar-links-dot"></div>
        <a href="https://www.facebook.com/profile.php?id=100089217293297" target="_blank" rel="noopener noreferrer" className="bottom-bar-ext-link">
          <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="#1877F2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
          <span>Facebook</span>
        </a>
        <div className="bottom-bar-links-dot"></div>
        <a href="https://www.post.ch/fr/expedier-des-colis/colis-suisse" target="_blank" rel="noopener noreferrer" className="bottom-bar-ext-link">
          <svg width="36" height="16" viewBox="0 0 90 40" xmlns="http://www.w3.org/2000/svg">
            <rect width="90" height="40" rx="4" fill="#FFD200"/>
            <rect x="6" y="10" width="20" height="20" rx="2" fill="#E00A17"/>
            <rect x="13" y="13" width="6" height="14" fill="white"/>
            <rect x="9" y="17" width="14" height="6" fill="white"/>
            <text x="32" y="28" fontFamily="Arial,sans-serif" fontWeight="900" fontSize="24" fill="#1a1a1a">Post</text>
          </svg>
          <span>{t('guides.shippingHelp')}</span>
        </a>
        <div className="bottom-bar-links-dot"></div>
        <a href="mailto:info@main2main.ch" className="bottom-bar-ext-link">
          <span>{'\u2709\uFE0F'}</span>
          <span>{t('guides.contactLink')}</span>
        </a>
        <div className="bottom-bar-links-dot"></div>
        <Link to="/mentions-legales" className="bottom-bar-ext-link">
          <span>{t('guides.legalLink')}</span>
        </Link>
        <div className="bottom-bar-links-dot"></div>
        <Link to="/cgv" className="bottom-bar-ext-link">
          <span>{t('guides.cgvLink')}</span>
        </Link>
        <div className="bottom-bar-links-dot"></div>
        <Link to="/politique-de-confidentialite" className="bottom-bar-ext-link">
          <span>{t('guides.privacyLink')}</span>
        </Link>
        <div className="bottom-bar-links-dot"></div>
        <a href="https://www.datawebsolution-ia.ch/" target="_blank" rel="noopener noreferrer" className="bottom-bar-ext-link">
          <span>{'\u{1F4BB}'}</span>
          <span>{t('guides.creatorLink')}</span>
        </a>
      </div>
    </div>
  );
};

export default BottomBar;
